module.exports = __webpack_public_path__ + "static/media/cell_algo.e753e96e.png";


//////////////////
// WEBPACK FOOTER
// ./src/Jiggle/Implementation/img/cell_algo.png
// module id = 291
// module chunks = 0